import {
  LOI_EDIT_LIMITS,
  loiDescriptionFieldError,
  loiTitleFieldError,
} from './LoiCardEdit.validation'

const { TITLE_MIN, TITLE_MAX, DESC_MIN, DESC_MAX } = LOI_EDIT_LIMITS

/** Tooltip when Save is disabled; "Save" when enabled. */
export function loiSaveToolbarTooltip(
  disabled: boolean,
  dirty: boolean,
  title: string,
  description: string,
  duplicateTitle: boolean,
): string {
  if (!disabled) return 'Save'
  if (!dirty) return 'Make changes before saving'
  const titleErr = loiTitleFieldError(title)
  if (titleErr) return titleErr
  if (duplicateTitle) {
    return 'Each LOI title must be unique in this campaign'
  }
  const descErr = loiDescriptionFieldError(description)
  if (descErr) return descErr
  const trimmedTitle = title.trim()
  if (trimmedTitle.length < TITLE_MIN || trimmedTitle.length > TITLE_MAX) {
    return `Title must be ${TITLE_MIN}–${TITLE_MAX} characters`
  }
  const trimmedDesc = description.trim()
  if (trimmedDesc.length < DESC_MIN || trimmedDesc.length > DESC_MAX) {
    return `Description must be ${DESC_MIN}–${DESC_MAX} characters`
  }
  return 'Complete all required fields to save'
}

/** Tooltip when Reset is disabled; "Reset changes" when enabled. */
export function loiResetToolbarTooltip(disabled: boolean, isSaving: boolean): string {
  if (!disabled) return 'Reset changes'
  if (isSaving) return 'Saving…'
  return 'No changes to reset'
}
